/**
 * useEmployee — React Query hook egyetlen HR dolgozó lekérdezéséhez
 */

import { useQuery } from '@tanstack/react-query';
import { getEmployee, type Employee } from '../api/hr-api';

export function employeeQueryKey(id: string) {
  return ['hr', 'employees', id] as const;
}

export function useEmployee(id: string | undefined) {
  return useQuery<Employee>({
    queryKey: id ? employeeQueryKey(id) : ['hr', 'employees', 'none'],
    queryFn: async () => {
      if (!id) throw new Error('Nincs dolgozó azonosító');
      const res = await getEmployee(id);
      return res.data;
    },
    enabled: Boolean(id),
    staleTime: 60_000,
  });
}
